import { DesignTokens } from "./tokens";

export function dialogPaperStyle(tokens: DesignTokens) {
  const c = tokens.color;
  return {
    backgroundColor: c.surface.elevated,
    border: `${tokens.borderWidth} solid ${c.border.default}`,
    borderRadius: tokens.radius.md,
    boxShadow: "none",
  } as const;
}

export function dialogTitleStyle(tokens: DesignTokens) {
  const c = tokens.color;
  return {
    padding: `${tokens.space[3]} ${tokens.space[3]} ${tokens.space[2]}`,
    fontSize: tokens.type.subheading.size,
    fontWeight: tokens.type.subheading.weight,
    lineHeight: tokens.type.subheading.lineHeight,
    color: c.text.primary,
  } as const;
}

export function dialogContentStyle(tokens: DesignTokens) {
  const c = tokens.color;
  return {
    padding: `${tokens.space[2]} ${tokens.space[3]}`,
    fontSize: tokens.type.body.size,
    lineHeight: tokens.type.body.lineHeight,
    color: c.text.primary,
  } as const;
}

export function dialogActionsStyle(tokens: DesignTokens) {
  return {
    padding: tokens.space[3],
    gap: tokens.space[2],
  } as const;
}

export function dialogOverridesV5(tokens: DesignTokens) {
  return {
    MuiDialog: { styleOverrides: { paper: dialogPaperStyle(tokens) } },
    MuiDialogTitle: { styleOverrides: { root: dialogTitleStyle(tokens) } },
    MuiDialogContent: { styleOverrides: { root: dialogContentStyle(tokens) } },
    MuiDialogActions: { styleOverrides: { root: dialogActionsStyle(tokens) } },
  };
}

export function dialogOverridesV4(tokens: DesignTokens) {
  return {
    MuiDialog: { paper: dialogPaperStyle(tokens) },
    MuiDialogTitle: { root: dialogTitleStyle(tokens) },
    MuiDialogContent: { root: dialogContentStyle(tokens) },
    MuiDialogActions: { root: dialogActionsStyle(tokens) },
  };
}
